export const iconFontAwesomeDisasterCrisisHouseFloodWater = (
	<i className="fa-solid fa-house-flood-water"></i>
);
